import { Variants } from 'motion/react';

export enum OnboardingPopup {
  Welcome = 'Welcome',
  Progress = 'Progress',
  CreateEmployee = 'CreateEmployee',
  MobileAppInvite = 'MobileAppInvite',
  EmployeeTable = 'EmployeeTable',
  CreateTask = 'CreateTask',
  SendMultipleTaskDocuments = 'SendMultipleTaskDocuments',
  MobileAppSignInstructions = 'MobileAppSignInstructions',
  ChooseBackground = 'ChooseBackground',
}

export enum OnboardingTooltip {
  CreateEmployeeButton = 'CreateEmployeeButton',
  CreateTaskButton = 'CreateTaskButton',
  CreateVacationTaskButton = 'CreateVacationTaskButton',
  MultipleTaskOperationButton = 'MultipleTaskOperationButton',
}

export type OnboardingStep = OnboardingPopup | OnboardingTooltip;

export const ONBOARDING_STEPS: OnboardingStep[] = [
  OnboardingPopup.Welcome,
  OnboardingPopup.Progress,
  OnboardingTooltip.CreateEmployeeButton,
  OnboardingPopup.CreateEmployee,
  OnboardingPopup.MobileAppInvite,
  OnboardingPopup.Progress,
  OnboardingPopup.EmployeeTable,
  OnboardingTooltip.CreateTaskButton,
  OnboardingTooltip.CreateVacationTaskButton,
  OnboardingPopup.CreateTask,
  OnboardingPopup.Progress,
  OnboardingTooltip.MultipleTaskOperationButton,
  OnboardingPopup.SendMultipleTaskDocuments,
  OnboardingPopup.MobileAppSignInstructions,
  OnboardingPopup.ChooseBackground,
];

export type StepsWithOverlay =
  | OnboardingTooltip.CreateEmployeeButton
  | OnboardingPopup.CreateEmployee
  | OnboardingTooltip.CreateTaskButton
  | OnboardingTooltip.CreateVacationTaskButton
  | OnboardingPopup.CreateTask
  | OnboardingTooltip.MultipleTaskOperationButton
  | OnboardingPopup.SendMultipleTaskDocuments;

const STEPS_WITH_OVERLAY = new Set<StepsWithOverlay>([
  OnboardingTooltip.CreateEmployeeButton,
  OnboardingPopup.CreateEmployee,
  OnboardingTooltip.CreateTaskButton,
  OnboardingTooltip.CreateVacationTaskButton,
  OnboardingPopup.CreateTask,
  OnboardingTooltip.MultipleTaskOperationButton,
  OnboardingPopup.SendMultipleTaskDocuments,
]);

export const isStepsWithOverlay = (
  step: OnboardingStep,
): step is StepsWithOverlay => {
  return STEPS_WITH_OVERLAY.has(step as StepsWithOverlay);
};

export const popupAnimationVariants: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};
